/**
 * Admin Users Page (PR A7)
 */
import React from 'react';
import AdminUsersPage from './AdminUsersPage';

const AdminUsers = () => {
  return <AdminUsersPage />;
};

export default AdminUsers;
